export class IndustryDiscountSearchParameters {
  private startIndex: number;
  private totalPerPages: number;
  private filterText: string;

  public getStartIndex(): number {
    return this.startIndex;
  }

  public getTotalPerPages(): number {
    return this.totalPerPages;
  }

  public getFilterText(): string {
    return this.filterText;
  }

  public setStartIndex(value: number) {
    this.startIndex = value;
  }

  public setTotalPerPages(value: number) {
    this.totalPerPages = value;
  }

  public setFilterText(value: string) {
    this.filterText = value;
  }
}
